import { render, staticRenderFns } from "./crudMenu.vue?vue&type=template&id=1e712bb7&scoped=true&"
import script from "./crudMenu.vue?vue&type=script&lang=js&"
export * from "./crudMenu.vue?vue&type=script&lang=js&"
import style0 from "./crudMenu.vue?vue&type=style&index=0&id=1e712bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e712bb7",
  null
  
)

export default component.exports